import { createContext, useContext, type ReactNode } from 'react'

type DashboardAudience = { base: string; preview: boolean }
const Audience = createContext<DashboardAudience | null>(null)

export function DashboardAudienceProvider({
  base,
  children,
}: {
  base: string
  children: ReactNode
}) {
  return <Audience.Provider value={{ base, preview: true }}>{children}</Audience.Provider>
}
export function useDashboardAudience(organizationId: number) {
  const audience = useContext(Audience)
  return (
    audience ?? {
      base: `/api/v1/member_portal/organizations/${organizationId}/dashboard`,
      preview: false,
    }
  )
}
